(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // data-image-modal 属性を持つトリガーにクリックイベント設定
    document.querySelectorAll('[data-image-modal]').forEach(function (trigger) {
      trigger.style.cursor = 'pointer';
      trigger.addEventListener('click', function () {
        var dialog = document.getElementById(this.dataset.imageModal);
        if (dialog) {
          dialog.showModal();
        }
      });
    });

    // バックドロップクリックで閉じる
    document.querySelectorAll('dialog.image-modal').forEach(function (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === this) {
          this.close();
        }
      });

      // 閉じるボタン
      var closeBtn = dialog.querySelector('.image-modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }
    });
  });
})();
